import { render, staticRenderFns } from "./SettingsClinicalUsersExtraActionButtons.vue?vue&type=template&id=b1adfe4c"
import script from "./SettingsClinicalUsersExtraActionButtons.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalUsersExtraActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports